export const API_URL = process.env.REACT_APP_API_URL;

export function getWithdrawUrl() {
    return API_URL + '/withdraw';
}

export function getTransferUrl(code) {
    return API_URL + `/coin/withdraw?code=${code}`;
}